const bundleBuilder = ()=> ({
  data: {},
  bundle_items: [],
  bundle_items_property: [],
  products: [],
  bundle_items_left: 0,
  open: false,

  get bundleUncomplete() {
    return this.bundle_items.length > 0 && this.bundle_items.length < this.data.bundle_size;
  },

  get disabledAddToCart() {
    return this.bundle_items.length < this.data.bundle_size;
  },

  disabledProduct(id) {
    return !this.disabledAddToCart && !this.bundle_items.includes(id) ? 'disabled' : false;
  },

  getInitialData() {
    const structuredData = document.getElementById('widget_data');
    if (structuredData) {
      this.data = JSON.parse(structuredData.innerHTML);
      this.createNutritionModule();
      
      this.bundle_items_left = this.data.bundle_size;
    }
  },

  addBundleItem(id) {
    if(!this.disabledAddToCart) return;
    this.bundle_items.push(id);
    this.$el.classList.add('active');

    setTimeout(()=> {
      this.$el.classList.remove('active');
      this.$el.classList.add('added');
    }, 900) 
  },

  increaseQuantity(id) { 
    if(!this.disabledAddToCart) return;
    this.bundle_items.push(id);
  },

  decreaseQuantity(id) {
    const index = this.bundle_items.findLastIndex(item => item === id);
    if (index > -1) {
      this.bundle_items.splice(index, 1);
    }

    if(!this.bundle_items.includes(id)) {
      this.$el.parentElement.previousElementSibling.classList.remove('added');
    }
  },

  changeQuantity(id) {
    const allAreEqual = this.bundle_items.every(item => item === id);
    if(this.$el.valueAsNumber === 0) {
      this.bundle_items = this.bundle_items.filter(item => item !== id);
    } else {
      if(allAreEqual) {
        if(this.$el.valueAsNumber >= this.data.bundle_size) {
          this.$el.value = this.data.bundle_size;
        }
      } else {
        const existingItemsLength = this.bundle_items.filter(item => item !== id).length;
        const quantity = this.data.bundle_size - existingItemsLength;
        if(this.$el.valueAsNumber > quantity) {
          this.$el.value = quantity;
        }
      }
      this.changeQuantityOperation(id);
    } 
  },

  changeQuantityOperation(id) {
    const desiredCount = parseInt(this.$el.value, 10);
    const currentCount = this.bundle_items.filter(el => el === id).length;

    if (desiredCount > currentCount) {
      const toAdd = desiredCount - currentCount;
      
      this.bundle_items.push(...Array(toAdd).fill(id));
    } else if (desiredCount < currentCount) {
      let toRemove = currentCount - desiredCount;
      this.bundle_items =  this.bundle_items.filter(el => {
        if (el === id && toRemove > 0) {
          toRemove--;
          return false;
        }
        return true;
      });
    }
  },

  removeBundleItem(id, index) {
    this.bundle_items.splice(index, 1);
    const addButton = document.getElementById(`add-${id}`);
    if (addButton) {
      addButton.classList.remove('added');
    }
  },

  itemCount(id) {
    const quantityMap = {};
    for (const id of this.bundle_items) {
      quantityMap[id] = (quantityMap[id] || 0) + 1;
    }

    const lines = Object.entries(quantityMap).map(
      ([id, qty]) => ({
        variant_id: id,
        quantity: qty
      })
    );
    const line = lines.find(line => Number(line.variant_id) === id);
    return line ? line.quantity : 0
  },

  buildProducts() {
    this.products = this.bundle_items.map(id => this.data.bundle_items.find(product => product.id === id)) .filter(Boolean);
  },

  buildBundleItems() {
    const groupedProducts = {};
    for (const product of this.products) {
      const key = product.id;
      if (!groupedProducts[key]) {
        groupedProducts[key] = { title: `${product.title} - ${product.size}`, quantity: 1 };
      } else {
        groupedProducts[key].quantity++;
      }
    }
    
    const itemTitles = Object.values(groupedProducts).map(entry => entry.quantity > 1 ? `${entry.title} ×${entry.quantity}` : entry.title);

    return itemTitles;
  },

  buildBundleItemsProperty() {
    this.bundle_items_property = this.bundle_items.map(item => `gid://shopify/ProductVariant/${item}`).join(',');
  },


  async addToCart() {
    const mainVariantID = `gid://shopify/ProductVariant/${this.data.id}`;
    const url = `${window.Shopify.routes.root}cart/add.js`;
    const bundleProperties = {
      _main_product_id: mainVariantID,
      _bundle_items_id: this.bundle_items_property,
      _price_per_unit: (this.data.price / this.data.bundle_size).toFixed(2)
    }

    this.buildBundleItems().forEach((item, index) => {
      bundleProperties[`#${index + 1}`] = item;      
    });

    const bodyRequest = {
      items: [
        {
          id: this.data.id,
          quantity: 1,
          properties: bundleProperties
        }
      ],
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname
    }

    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(bodyRequest)
    };

    try {
      const response = await fetch(url, config);
      if (!response.ok) throw new Error("Failed to add to cart");

      const result = await response.json();
      this.getSectionsToRender().forEach(section => {
        const sectionToUpdate = document.querySelector(`#${section.id}`);
        const updatedSection = this.getSectionFromResponse(result.sections[section.section], `#shopify-section-${section.id}`);
        
        if(sectionToUpdate && updatedSection) {
          sectionToUpdate.innerHTML = updatedSection.innerHTML;
          const cartDrawerOpen = document.querySelector('cart-drawer details summary');
          this.$el.classList.add('added');
          setTimeout(()=> {
            this.open = false;
            document.dispatchEvent(new CustomEvent('bundle::added', {detail: { element: cartDrawerOpen }}));
          },1500)

          setTimeout(()=> {
            this.$el.classList.remove('added');
          },2500)
        }
      })
      
    } catch (error){
      console.log(error);
    }
  },

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  },

  getSectionFromResponse(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  },

  openPopup() {
    this.open = true;
    document.body.classList.add('overflow-hidden');
  },

  closePopup() {
    this.open = false;
    document.body.classList.remove('overflow-hidden');
  },

  handleStickyCta() {
    const anchor = document.querySelector('.bundle-builder');
    this.$nextTick(()=> {
      const anchorBottomPosition = anchor.offsetTop + anchor.clientHeight - 60;
      if(window.innerWidth >= 990) {
          window.addEventListener('scroll', ()=> {
            window.scrollY >= anchorBottomPosition ? this.$refs.stickyBundleCta.classList.add('active') : this.$refs.stickyBundleCta.classList.remove('active');
        })
        } else {
          const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.$refs.stickyBundleCta.classList.remove('active')
              } else {
                this.$refs.stickyBundleCta.classList.add('active');
              }
            });
          },  {
            rootMargin: '0px',
            threshold: 0.4
          })

          observer.observe(anchor);
        }
    })
  },

  showDescription() {
    const bundleItemsDescriptions = document.querySelectorAll('.bundle-builder__descriptions .accordion');
    bundleItemsDescriptions.forEach(description => description.classList.remove('active'));
    
    this.bundle_items.forEach(item => {
      const description = document.getElementById(`bundle-item-description-${item}`);
      if(description) {
        description.classList.add('active');
      }
    })
  },

  createNutritionModule() {
    function createTableRow(values) {
      const tr = document.createElement('tr');
      values.forEach(value => {
          const td = document.createElement('td');
          td.textContent = value;
          tr.appendChild(td);
      });
      return tr;
    }

    function createTableHead(table, nutritionData) {
      const thead = document.createElement('thead');
      const headerRow = document.createElement('tr');

      for (const col in nutritionData) {
        const th = document.createElement('th');
        th.textContent = nutritionData[col].title;
        headerRow.appendChild(th);
        thead.appendChild(headerRow);
      }
      table.appendChild(thead);
    }

    function createTableBody(table, nutritionData) {
      const tbody = document.createElement('tbody');
      const dataValues = Object.keys(nutritionData).map(col => nutritionData[col].values);

      for (let i = 0; i < dataValues[0].length; i++) {
        const rowData = dataValues.map(column => column[i]);
        const row = createTableRow(rowData);
        tbody.appendChild(row);
      }
      table.appendChild(tbody);
    }

    function createTable(placeholder, data) {
      const table = document.createElement('table');
      createTableHead(table, data)
      createTableBody(table, data);
      placeholder.appendChild(table);
    }

    this.data.bundle_items.forEach(item => {
      const placeholder = document.querySelector(`.nutrition-${item.id}`);
      const data = item?.nutrition_data;
      if(placeholder && data) {
        createTable(placeholder, data)
      }
    })
  },

  init() {
    this.getInitialData();
    this.$watch('bundle_items', ()=> {
      this.buildProducts();
      this.buildBundleItemsProperty();
      this.showDescription();
      
      this.bundle_items_left = this.data.bundle_size - this.bundle_items.length;
    })

    this.handleStickyCta();
  }
})

document.addEventListener('alpine:init', ()=> {  
  Alpine.data('bundleBuilder', bundleBuilder)
})